import { api, unwrap } from './client';

export async function listPendingApprovals(page = 0, size = 10) {
  const res = await api.get(`/finance/workflows/paginated/pending?page=${page}&size=${size}`);
  return unwrap(res)?.content || [];
}

export async function listSubmittedWorkflows(page = 0, size = 10) {
  const res = await api.get(`/finance/workflows/paginated/submitted?page=${page}&size=${size}`);
  return unwrap(res)?.content || [];
}

export async function listWorkflowsFilter(params) {
  const queryString = new URLSearchParams({ page: 0, size: 10, ...params }).toString();
  const res = await api.get(`/finance/workflows/paginated/filter?${queryString}`);
  return unwrap(res)?.content || [];
}

export async function getWorkflowForEntity(entityType, entityId) {
  const res = await api.get(`/finance/workflows/${entityType}/${entityId}`);
  return unwrap(res);
}

/**
 * action: 'APPROVED' | 'REJECTED' | 'REVISION_REQUESTED' (also accepts 'APPROVE')
 * comment: optional string
 */
export async function actOnWorkflow(id, { action, comment }) {
  const res = await api.post(`/finance/workflows/${id}/act`, { action, comment });
  return unwrap(res);
}
